export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'

export const endpoints = {
    LOGIN: '/admin/api/auth/login',
    REFRESH_TOKEN: '/admin/api/auth/refresh',
}
